module.exports = __webpack_public_path__ + "img/undraw_step_to_the_sun_nxqq.62f3867e.svg";